import { makeStyles } from "@material-ui/core";

const useGlobalClasses = makeStyles(({ globalStyles }) => globalStyles);

export default useGlobalClasses;
